<template>
    <div class="translating-box" v-if="props.state !== 'done'">
        <div class="translating" v-if="props.state === 'loading'">
            <div class="color-#000">{{ t('toast.translating') }}</div>
            <div class="w-14px h-14px">
                <img src="@/assets/images/chat/chatTosatTranslateLoading/loading.webp" alt=""
                    class="w-full h-full animate-spin mb-10px" />
            </div>
        </div>

        <div class="translating-completed" v-if="props.state === 'success'">
            <div class="color-#000">{{ t('toast.translate') }}</div>
            <div class="w-14px h-14px ml-8px">
                <img src="@/assets/images/chat/chatTosatTranslateLoading/completed.webp" alt=""
                    class="w-full h-full  mb-10px" />
            </div>
        </div>
        <div v-else-if="props.state === 'error'">
            <div class="translating">{{ t('toast.translationFailed') }}</div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
interface Props {
    show?: boolean
    isAllTranslate?: boolean
    message?: string
    state?: string
}
const props = withDefaults(defineProps<Props>(), {
    show: false,
    isAllTranslate: false,
    message: ''
})
// 定义事件
const emit = defineEmits<{
    'update:show': [value: boolean]
}>()
</script>
<style lang="scss" scoped>
:deep(.custom-toast) {
    width: 112px;
    height: 32px;
    border-radius: 16px;
}

.translating-box {
    position: fixed;
    bottom: 10%;
    left: 50%;
    transform: translate(-50%, -50%);
    // width: 112px;
    height: 32px;
    background: #FFFFFF;
    border-radius: 16px;
}

.translating {
    width: 112px;
    height: 32px;
    background: #FFFFFF;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    font-size: 12px;
}
.translating-completed{
    // width: 82px;
    height: 32px;
    padding: 8px;
    background: #FFFFFF;
    border-radius: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #333;
    font-size: 12px;
}
</style>
